// libs
import React, { memo } from "react";
import Helmet from "react-helmet";

// global components
import Boot from "shared/components/Boot";

// Routes
import Routes from "shared/routes";

// styles
import BaseStyles from "./styles/BaseStyles";

// components
import { ResponsiveObserver } from "shared/components/ResponsiveLoader";

// constants
import { DEFAULT_TITLE, FAVICON } from "shared/constants";

function App({ deviceWidth }: { deviceWidth: number }) {
    return (
        <ResponsiveObserver deviceWidth={deviceWidth}>
            <BaseStyles />
            <Helmet
                defaultTitle={DEFAULT_TITLE}
                titleTemplate="%s"
                link={[
                    {
                        rel: "icon",
                        type: "image/png",
                        href: FAVICON,
                    },
                ]}
            />
            <Boot />
            <Routes />
        </ResponsiveObserver>
    );
}

export default memo(App);
